export interface IAppReportTemplateListItem {
    id: string;
    companyId: string;
    code: string;
    comment: string;
    activeState: number;
}

export class AppReportTemplateListItem implements IAppReportTemplateListItem {
    id: string;
    companyId: string;
    code: string;
    comment: string;
    activeState: number;

    constructor();
    constructor(obj: IAppReportTemplateListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.companyId = obj && obj.companyId || "";
        this.code = obj && obj.code || "";
        this.comment = obj && obj.comment || "";
        this.activeState = obj && obj.activeState || 0;
    }
}